export const query = `query getCategoryInitialDataAlwaysFetchCategories($externalId: String!, $currentCategoryId: String!, $withRichContentDescription: Boolean = false) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    isCatalogV3
    categories {
      list {
        id
        name
        slug
        visible
        parentCategoryId
        parentCategoryIndex
      }
    }
    category(categoryId: $currentCategoryId) {
      richContentDescription @include(if: $withRichContentDescription)
      promotions {
        position
      	promotion {
          id
          destinationUrl
          media {
            image {
              id
              url
              height
              width
              altText
            }
          }
        }
      }
    }
    allProductsCategoryId
  }
}
`;
